define('app-Gdpr/settings',[],function () {
    return {
        retrieveFormUrl: window.location.protocol + "//" + window.location.host + "/gdpr/AskPermissionNameAndAddress",
        AddUpdatePermissionUrl: window.location.protocol + "//" + window.location.host + "/gdpr/AddUpdatePermission",
        gdprFormContent: "#gdpr-content",
        grandParentRadioButtons: "input[type='radio'][name='grandParent']",
        parentConsentsContainer: "#parent-consent-container",
        parentConsentCheckboxes: "#parent-consent-container input[type='checkbox']",
        acknowledgement: "#gdpr-acknowledgement",
        overlayLinks: ".overlay-link",
        parentValidationMessage: "#parent-validation",
        grandParentValidationMessage: "#grand-parent-validation"
    };
});
